/* eslint-disable import/no-unresolved */

import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import desktopImageWebp from './images/estate-planning-hero-desktop.webp';
import mobileImageWebp from './images/estate-planning-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='estate-planning-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Estate Planning'
      headingText={
        <>Feel good today knowing tomorrow is taken <WidowBlock>care of.</WidowBlock></>
      }
      descriptionText={
        <>Having a plan for your estate&#8212;your home, your  wealth, your possessions&#45;means you can leave the legacy you want, whether that&#39;s to help your family, a charity, or <WidowBlock>an institution.</WidowBlock></>
      }
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Start planning',
        ariaLabel: 'Start planning with a financial advisor.',
        children: '',
      }}
      backgroundImageAriaLabel='a mother wearing a gray sweater kissing her daughter on the cheek with her eyes clothes wearing a gray sweater and pink knitted hat'
      backgroundImageDesktop={desktopImageWebp.toString()}
      backgroundImageMobile={mobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
